import { faFilter, faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import ComponenteFiltros from './ComponenteFiltros';

const FiltrosMapa = ({ filtros, setFiltros, limpiarPoligonosYMarcadores, expanded, datosMapa }) => {
  const [mostrarModal, setMostrarModal] = useState(false);

  const abrirModal = () => {
    setMostrarModal(true);
    document.body.style.overflow = 'hidden'; // Bloquear scroll de fondo
  };

  const cerrarModal = () => {
    setMostrarModal(false);
    document.body.style.overflow = 'auto'; // Restaurar scroll de fondo
  };

  return (
    <div>
      <div className='bg-white md:pt-5 lg:p-0'>
        {/* Barra de filtros para escritorio */}
        <div className='hidden md:flex w-full p-4 items-center'>
          {expanded && (<button
            type="button"
            onClick={abrirModal}
            className="px-4 flex justify-center items-center rounded-full bg-gray-200 ml-4 shrink-0 p-3"
          >
            <FontAwesomeIcon icon={faFilter} className="w-4 h-4 mr-2 text-gray-700" /> Refinar
          </button>)}
          <ComponenteFiltros
            filtros={filtros}
            setFiltros={setFiltros}
            limpiarPoligonosYMarcadores={limpiarPoligonosYMarcadores}
            esModal={false}
            expanded={expanded}
            className="flex-grow"
            cerrarModal={cerrarModal}
            datosMapa={datosMapa}
          />
          <button
            type="button"
            onClick={abrirModal}
            className="px-4 flex justify-center items-center rounded-full bg-gray-200 ml-4 shrink-0 p-3"
          >
            <FontAwesomeIcon icon={faFilter} className="w-4 h-4 mr-2 text-gray-700" /> Refinar
          </button>
        </div>

        {/* Modal de filtros */}
        {mostrarModal && (
          <div className='fixed inset-0 bg-gray-900 bg-opacity-50 z-50 overflow-y-auto flex'>
            <div className='bg-white w-11/12 max-w-xl p-6 rounded-lg m-auto'>
              <div className='flex justify-between items-center mb-4'>
                <h2 className='text-xl font-bold'>Refinar búsqueda</h2>
                <FontAwesomeIcon icon={faTimes} className='w-6 h-6 cursor-pointer' onClick={cerrarModal} />
              </div>

              <ComponenteFiltros
                filtros={filtros}
                setFiltros={setFiltros}
                limpiarPoligonosYMarcadores={limpiarPoligonosYMarcadores}
                esModal={true}
                expanded={expanded}
                cerrarModal={cerrarModal}
              />
            </div>
          </div>
        )}
      </div>

      {/* Botón flotante para dispositivos móviles, parte superior derecha */}
      <div className="fixed top-40 right-3 z-[2] md:hidden lg:hidden">
        <button
          type="button"
          onClick={abrirModal}
          className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-transform
                  focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none
                  disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 rounded-full p-2 bg-white shadow-lg transform hover:scale-105"
        >
          <FontAwesomeIcon icon={faFilter} className="h-4 w-6 text-gray-700 dark:text-gray-700 transition-transform transform hover:-translate-x-[1px]" />
        </button>
      </div>
    </div>

  );
};

export default FiltrosMapa;
